import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
// import { Subscription } from "rxjs/Subscription";
import { ValidateService } from '../../../services/validate.service';
import { AuthService } from '../../../services/auth.service';
import { UserResponse } from '../../../models/User';
import { BootstrapRelayService } from '../../../services/bootstrap-relay.service';
import { Router } from '@angular/router';
import { FlashService } from '../../../services/utility/flash.service';
import { AuthenticateResponse } from '../../../models/User';
import * as $ from 'jquery';

@Component({
  selector: 'app-nav-signin',
  templateUrl: './nav-signin.component.html',
  styleUrls: ['./nav-signin.component.scss']
})
export class NavSigninComponent implements AfterViewInit, OnDestroy{
  @ViewChild('myModal') myModal:ElementRef;
  // subscriptions:Set<Subscription> = new Set();
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  showModal: boolean = true;
  isLoggedIn: boolean = false;
  email: string = '';
  password: string = '';
  $e?: object;

  constructor(
    private elementRef:ElementRef,
    private validateService:ValidateService,
    private authService:AuthService,
    private router:Router,
    private bootstrapRelayService:BootstrapRelayService,
    private flashService:FlashService,
  ) { }
  
  // onChange($event){
  
  // }


  //Note - nav-signin.component will be destroyed upon user login, due to ng-if inside navbar.component.html that conditionally utilizes nav-signin.
  ngAfterViewInit() {
    // console.log('nav-signin ngAfterViewInit');
    // console.log('registering...');
    this.bootstrapRelayService.registerEvent('hidden.bs.modal');
    // console.log('done registering');
    // let subscription$ = Observable.fromEvent(this.elementRef.nativeElement, 'hidden.bs.modal')
    
    Observable.fromEvent(this.elementRef.nativeElement, 'hidden.bs.modal')
    .takeUntil(this.ngUnsubscribe)
    .subscribe(($event) => {
      // console.log('nav-signin observed hidden.bs.modal');
      if(this.isLoggedIn){
        //user logged in, display message
        this.flashService.flashMessage.show('You are logged in', { cssClass: 'alert-success', timeout: 4000 });
      }
    });

    // this.subscriptions.add(subscription$);

  }

  ngOnInit(){
    // console.log('nav-signin init');

    $('#flashEmail').hide();
    $('#flashPassword').hide();

    // when modal is about to lose focus
    Observable.fromEvent($('#myModal'), 'focusout')
    .takeUntil(this.ngUnsubscribe)
    .subscribe(() => {
      this.showModal = true;
    });

    this.authService.user$
    .takeUntil(this.ngUnsubscribe)
    .subscribe(user => {
      if(!user){
        // console.log('nav-signin sees user logged out');
        this.isLoggedIn = false;
      }
    })
  }

  

  onLoginSubmit($e){
    let flashEmailId = '#flashEmail';
    let flashPasswordId = '#flashPassword';
    $(flashEmailId).hide();
    $(flashPasswordId).hide();
    //Guard: Required Fields
    let vlogin = this.validateService.validateLogin(this.email, this.password);
    // console.log('vlogin', vlogin);
    if(!vlogin.success){
      //validation error...
      switch (vlogin.field) {
        case 'email':
        this.flashService.flashElementWithId(flashEmailId, vlogin.msg, 4000);
        break;
        case 'password':
        this.flashService.flashElementWithId(flashPasswordId, vlogin.msg, 4000);
        break;
        case 'both':
        this.flashService.flashElementWithId(flashEmailId, vlogin.msg, 4000);
      }
      return;
    } 

    //login user using authService
    this.authService.loginUser(this.email, this.password)
    .first().subscribe((authResponse:AuthenticateResponse) => {
      let user = authResponse.user;
      // console.log('nav signin callback shows user logged in');
      this.isLoggedIn = true;
      //dismiss the modal
      this.showModal = false
      // setTimeout(function() {
        $('#btnClose').click();  
      // }, 1500);
      if(user.account_type == 'catadmin'){
        this.router.navigate(['/admin']);
      } else {
        this.router.navigate(['/account']);
      }
      //this component observes 'hidden.bs.modal', will notice user logging in
      // and display flash message at the app.component level.
      },
      (errResponse: AuthenticateResponse) => {  
        console.log('nav-signin: error logging in');
        this.flashService.flashElementWithId(flashEmailId, errResponse.msg, 4000);
          //use err.message returned by server to display to the user        
          // this.flashMessagesService.show(errResponse.msg, { cssClass: 'alert-danger', timeout: 4000 });
      }
    );
  }




  //The official way to unsubscribe all component subscriptions.
  // https://stackoverflow.com/questions/38008334/angular-rxjs-when-should-i-unsubscribe-from-subscription
  ngOnDestroy() {
    // console.log('nav-signin destroy');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
}


  // //this doesn't affect behavior.  But is supposedly good practice.
  // ngOnDestroy(){
  //   // console.log('destroying component nav-signin');
  //   // console.log('subscriptions', this.subscriptions);
  //   this.subscriptions.forEach((subscription$:Subscription) => {
  //     subscription$.unsubscribe();
  //     this.subscriptions.delete(subscription$);
  //   });
  // }

}





//==============
//Unused Code

    // console.log(this.myModal);
    // $(this.myModal.nativeElement).on('shown.bs.modal', function (e) {
    //     console.log('shown');
    // });

    // $('#myModal').on('shown.bs.modal', function (e) {
    //   console.log('shown');
    // });
    // console.log(this.elementRef);
    // $(this.elementRef.nativeElement).on("hidden.bs.modal", () => {
    //   console.log('modal event!');
  //     // this._zone.run(() => {
  //     //   this.initialize();    
  //     // });
    // });

    // //This works only in script of body tag.  doh!  maybe do document.ready
    // $(document).ready(function() {
    //   $('body').on("hidden.bs.modal", '.modal', function(e){
    //     console.log(e);
    //     console.log('ready to blur');
    //       // $('#myModalLink').html("Hi");
    //     $('#myModalLink').blur();
    //   });
    // });

  // //this works!  It's a general solution.
  // $('a').focus(function() {
  //   console.log('a received focus');
  //   // setTimeout(() => {
  //     $(this).blur();  
  //     console.log('a blurred');
  //   // }, 3000);
  // });

    // value = 0;
  // @ViewChild('myModal') myModal:ElementRef;
  // constructor(private elementRef: ElementRef) { }

  // export enum KEY_CODE {
//   RIGHT_ARROW = 39,
//   LEFT_ARROW = 37
// }
// angular.element(document).find('.modal').on('hidden.bs.modal', function(){
    // do something
  //   console.log('function fired');
  // });
  // console.log(this.myModal);

  // let modalElement = document.getElementById('myModal');
  // console.log('modal element:', modalElement);
  // modalElement.addEventListener("hidden.bs.modal", this.onModalHidden);
  // modalElement.addEventListener("shown.bs.modal", this.onModalShown);
    // this.router.events.subscribe((e) => {
    //   if (e instanceof NavigationEnd) {
    //     console.log('nav-signin.component url: '+e.url); 

    //     $(document).on('hidden.bs.modal', '#myModal', function(){
    //       console.log('hi there');
    //     });

    //     // this.activate();
    //     //both of these work, but they scroll the entire window to the top.  not just the current component.
    //     // window.scrollTo(0, 0);
    //     // document.body.scrollTop = 0;

    //     //click event works, but not hidden.bs.modal
    //     // let eventStream$ = Observable.fromEvent(this.elementRef.nativeElement, 'click');
    //     // eventStream$.subscribe(() => {
    //     //   console.log('hi there');
    //     // });

    //     // //This works only in script of body tag.  doh!  maybe do document.ready
        
    //     //   $('body').on("hidden.bs.modal", '.modal', function (e) {
    //     //     console.log(e);
    //     //     console.log('ready to blur');
    //     //     // $('#myModalLink').html("Hi");
    //     //     $('#myModalLink').blur();
    //     //   });
        
    //   }
    // });

    // @ViewChild('mmmodal') public myModal:ElementRef;  //must include #mmmodal in the tag you want to reference
// constructor(private elementRef:ElementRef, private ngZone: NgZone) {
  // console.log('mmmodal: ', this.myModal);
// }

 // setTimeout(()=>{
    //   document.addEventListener("hide.bs.modal", this.onModalHidden);
    //   console.log('added event listener');
    // }, 2000);

    // this.myModal.nativeElement.addEventListener("hidden.bs.modal", this.onModalHidden);
    // let modalElement = document.getElementById('myModal');
    // console.log('modal element:', modalElement);
  // modalElement.addEventListener("hidden.bs.modal", this.onModalHidden);
  // modalElement.addEventListener("shown.bs.modal", this.onModalShown);
    // $(".modal").on("shown.bs.modal", function() {
    //   console.log('hi');
    //   this._zone.run(() => {
    //     console.log('hi2');
    //   });
    //   // $(this).find("#myModal").focus() // also tried wrapping in setTimeout
    // });

    // this.activate();

    // $(document).ready(function() {  
    //   console.log('hello');
    // });
    // console.log('hello2');

     // $(".modal").on("hidden.bs.modal", function()  { // any time a modal is hidden
    //   alert('hi');
    //   // var urlReplace = window.location.toString().split('#', 1)[0]
    //   // history.pushState(null, null, urlReplace); // push url without the hash as new history item
    // });

    // $('#myModal').modal();
    // $(window).on('show.bs.modal', function (e) {
    //     alert('show test');
    // });

    // $(document).on('shown.bs.modal','.modal', function () {
    //   alert('show test');
    //   /// TODO EVENTS
      
    //   });

    // $(document).on('show.bs.modal','body', function () {
    //   alert('hi');
    // })
       //This works only in script of body tag.  doh!  maybe do document.ready
    // $(document).ready(function() {
      // setTimeout(() => {
      //   console.log('hi');
      //   $('body').on("show.bs.modal", '.modal', function(e){
      //     console.log(e);
      //     console.log('ready to show');
      //       // $('#myModalLink').html("Hi");
      //     // $('#myModalLink').blur();
      //   });
      // }, 2000);
    
    // });
      // ////This event is fired immediately when the hide instance method has been called.
      // ///called to reset the events and the headers.
      // console.log($('#myModal'));
      // $('#myModal').on('bs.modal', function () {
      //   ////debugger;
      //   // do your work over here
      //   console.log("modal is closed hidden");
      // })
    
    
      // ////This event is fired when the modal has finished being hidden from the   user (will wait for css transitions to complete).
      // ///called to reset the events and the headers.
      // $('#myModal').on('hide.bs.modal', function () {
      //   ////debugger;
      //   // do your work over here;
    
      //   console.log("modal is closed hide");
      // })



  // @HostListener('window:keyup', ['$event'])
  // keyEvent(event: KeyboardEvent) {
  //   console.log(event);
    
  //   if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
  //     this.increment();
  //   }

  //   if (event.keyCode === KEY_CODE.LEFT_ARROW) {
  //     this.decrement();
  //   }
  // }
  
  // increment() {
  //   this.value++;
  // }
  
  // decrement() {
  //   this.value--;
  // }

      // $('a').focus(function() {
    //   console.log('a received focus');
    //   // setTimeout(() => {
    //     $(this).blur();  
    //     console.log('a blurred');
    //   // }, 3000);
    // });
    
    
      // clickedClose($event){
  //   let tag = $event.target;
  //   console.log('clickedClose event occured');
  //   // tag.blur();
  //   // console.log('blurred');
  // }

    // onModalHidden(){
  //   console.log('onModalHidden');
  // }

      // console.log('mmmodal', this.myModal);
    // this.myModal.nativeElement.bind('', this.activate);

    //   constructor(
//     private router:Router,
//     private elementRef: ElementRef
// ) { 
  
//   }
// @ViewChild('mmmodal') public myModal:ElementRef;  //must include #mmmodal in the tag you want to reference

  // activate() {
  //   console.log('activate...');
 
   
  //   }

  // import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
  // import { Router, NavigationEnd } from '@angular/router';
  // import { Observable, Observer } from 'rxjs';


  //   Observable
  //   .fromEvent($(document), 'hidden.bs.modal')
  //   .subscribe((e) => {
  //     console.log('observable!');
  //   }
  // );

  //This also works, but is hokey b/c you see the focus box before it blurs.
      //     setTimeout(() => {
    //   // console.log('afterviewinit');
    //   console.log($('#myModalLink'));
    //   // $('#myModalLink').html("Hi");
    //   $('#myModalLink').blur();
    // }, 500);


      // modalEventDetected($event){
  //   // these work, but can't access the animation end of the modal fade.
  //   //put this in the modal tag:  (focusout)="modalEventDetected($event)"
  //   console.log('modalEventDetected', $event);
  //       // setTimeout(() => {
  //     // console.log('afterviewinit');
  //     console.log($('#myModalLink'));
  //     // $('#myModalLink').html("Hi");
  //     $('#myModalLink').blur();
  //   // }, 500);

  // }

  
    // ngAfterViewInit() {
  //   console.log('ngAfterViewInit');
  //   // setTimeout(() => {
  //   //   console.log('afterviewinit');
  //   //   console.log($('#myModal'));
  //   // }, 5000);

  //   //this doesn't detect bootstrap events, unfortunately.  However it will work on natural DOM events.
  //   // just remove 'on' from the event names to use in angular:  https://www.w3schools.com/jsref/dom_obj_event.asp

  //   var modalevent = Observable.fromEvent($(document), 'hide.bs.modal');
  //   modalevent.subscribe(function (data) {
  //     console.log('modal event 1');
  //     console.log('zone', this.zone);
  //   });
  // }
  

  // clickedSignin($event){
  //   let tag = $event.target;
  //   console.log('clickedSignin');
  // }


  // ngOnInit(){
  //   console.log('ngOnInit');
  //   // var keyups = Observable.fromEvent($('body'), "keyup");
  //   // keyups.subscribe(function(data) {
  //   //     console.log(data);
  //   // });

  //   //prevent focus on anchor tags in navbar
  //   $('a').focus(function() {
  //     $(this).blur();  
  //   });
  // }

  // import { Observable, Observer } from 'rxjs';
  // import * as $ from 'jquery';
  

      // this.authService.authenticateUser(user).subscribe(data => {
    //   if(data.success){
    //     this.authService.storeUserData(data.token, data.user);
    //     this.flashMessagesService.show('You are now logged in', {cssClass: 'alert-success', timeout: 5000});
    //     this.router.navigate(['/dashboard']);
    //   } else {
    //     this.flashMessagesService.show(data.msg, {cssClass: 'alert-danger', timeout: 5000});
    //     this.router.navigate(['/login']);
    //   }
    // });
    // }

          // if (this.category != null){
      //   let filteredProducts = products.filter((product) => {
      //     return product.category == this.category;
      //   });
      //   this.products = filteredProducts;
      // } else {
      //   this.products = products;
      // }

          // let obs = Observable.fromEvent(this.myModal.nativeElement, 'shown.bs.modal'); 
    // obs.forEach((value: any) => { 
    //   // this.initialize(); 
    //   console.log('shown event!', value);
    // }, null);

    // $('body').on('hidden.bs.modal', '.modal', function (e) {
    // $(".modal").on("shown.bs.modal", function() {
    // $(this.myModal.nativeElement).on("shown.bs.modal", function() {
    //   this.zone.run(() => {
    //     console.log('hi console shown');
    //     this.myinit();
    //   });  
    //   // $(this).find("#myModal").focus() // also tried wrapping in setTimeout
    // });

    // @ViewChild('btnClose') btnClose:ElementRef;
    // this.btnClose.nativeElement.click();

          //filter the products to those in category
      // console.log('Successfully logged in user: ', user);

      // $('#myModal').hide();

              // this.flashMessagesService.show('You are logged in', { cssClass: 'alert-success', timeout: 4000 });
        // this.router.navigate(['/account']); //optionally navigate to profile page showing user summary, including list of orders and delivery dates

                // this.shouldFade = false
        // this.btnClose.nativeElement.click();
        // this.router.navigate(['/login']); //optionally return home?  but need to dismiss modal.

      // () => {
      //   //this is not called upon error.  only upon observer calling complete on the observable.
      //   console.log('Completed');
      // }

      //Works!
          // $(this.myModal.nativeElement).on('shown-bs-modal', ($event) => {
    //   console.log('hidden figures -- ngAfterViewInit');
    //   // console.log('modal changed with event:', $event);    
    //   console.log('tada!');
    // });


    // //bootstrap hide event
    // this.bootstrapRelayService.registerEvent('hide.bs.modal');
    // Observable.fromEvent(this.myModal.nativeElement, 'hide.bs.modal')
    // .subscribe(($event) => {
    //   console.log('hide.bs.modal was triggered with event: ', $event);
    //   this.isLoggedIn = false;
    // });
    // console.log('registering hidden.bs.modal in nav-signin component');

        // // when modal appears
    // Observable.fromEvent($('#myModal'), 'focusin').subscribe(() => {
    //   this.isLoggedIn = false
    // });


        // this.authService.authServiceLoggedInUser.subscribe(user => {
    //   console.log('nav-signing sees user logging in');
    //   this.isLoggedIn = true;
    //   this.showModal = false;
    //   console.log('modal-content:', $('.modal-content'));
    // });

    //observe changes in login to update isLoggedIn flag for FlashMessages
    //*flashmessages shall only show in this component if user is not logged in.
    // this.authService.didLogOutUser
    // .takeUntil(this.ngUnsubscribe).subscribe(user => {
    //   console.log('nav-signin sees user logged out');
    //   this.isLoggedIn = false;
    // });



// WEBPACK FOOTER //
// ./src/app/components/navbar/nav-signin/nav-signin.component.ts